import { useI18n } from "../../i18n";
import { ConversationList } from "../ConversationList";

/**
 * Sidebar for the 对话 surface. In our unified model 对话 is a workspace whose
 * "channels" are past conversations, so the conversation history is the sidebar
 * list (+ a "new chat" action), mirroring the workspace's channel list.
 */
export function ChatSidebar({
  conversationId,
  version,
  onSelect,
  onNewChat,
}: {
  conversationId: string | null;
  version: number;
  onSelect: (id: string) => void;
  onNewChat: () => void;
}) {
  const { t } = useI18n();
  return (
    <aside className="ws-side">
      <div className="ws-side-head">
        <span className="ws-side-headtitle">{t("workspace.chat")}</span>
      </div>
      <div className="ws-side-scroll">
        <div className="ws-side-section">
          <div className="ws-side-section-head">
            <span className="ws-side-label">{t("collab.chat.history")}</span>
            <button type="button" className="ws-icon-btn" onClick={onNewChat} title={t("collab.chat.new")} aria-label={t("collab.chat.new")}>
              +
            </button>
          </div>
          <ConversationList selectedConversationId={conversationId} version={version} onSelect={onSelect} />
        </div>
      </div>
    </aside>
  );
}
